import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

// Primary shades
const PRIMARY_SHADES = ['#084b9b', '#1F77B4', '#357ABD', '#2B6EA6', '#8FB1CC'];
const SECONDARY_COLOR = '#97999b';

export const getStatusColor = (status, index) => {
    if (status?.toLowerCase() === 'rejected-policy-application') {
        return SECONDARY_COLOR;
    }
    if (status?.toLowerCase() === 'submitted-in-easipol') {
        return '#5e768f'; // Greyish blueish color
    }
    // For other statuses, pick from primary shades
    return PRIMARY_SHADES[index % PRIMARY_SHADES.length];
};

class DonutChart extends Component {
    
    constructor(props) {
        super(props);
        
        let chartValues = [];
        let chartLabels = [];
        let chartColors = [];
        props.getApplicationsByStatus.forEach((data, index) => {
            chartValues.push(data.count)
            chartLabels.push(data.status)
            chartColors.push(getStatusColor(data.status, index))
        })
 
        this.state = {
            series: chartValues,
            options: {
                chart: {
                    height: 220,
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                labels:chartLabels,
                fill: {
                    colors: chartColors
                },
                colors: chartColors,
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            show: false
                        }
                    }
                }],
                legend: {
                    show: false,
                    position: 'right',
                    offsetY: 0,
                    height: 150,
                }
            },
        };
    }

    render() {
        return (
            <ReactApexChart options={this.state.options} series={this.state.series} type="donut" height={220} />
        );
    }
}

export default DonutChart;